export default __webpack_public_path__ + "static/media/drl.3300c8ee.png";